import config from "@root/config.js"

// The availability states from the PLP redesign "Out of stock" user stories.
// The FLOW (notify vs coming-soon vs in-store vs no-action) is driven by the product-level `stock:` tag;
// in-stock status per variant comes from `variant.availableForSale`.
export type VariantAvailabilityState = "available" | "oos-no-action" | "oos-notify" | "coming-soon" | "in-store"

const { comingSoon, backSoon, inStore, outOfStock } = config.settings.product

// Mirror useOutOfStock's tag lookup so the card and drawer classify products identically.
export const getStockValue = (product: any): string | null => {
  const tag = product?.tags?.find((t: string) => t?.includes("stock:"))
  return tag ? tag.split(":")[1] : null
}

export const getVariantAvailabilityState = (variant: any, product: any): VariantAvailabilityState => {
  const stockValue = getStockValue(product)

  // Coming-soon is a product-level, pre-launch state that dominates variant stock.
  if (stockValue === comingSoon) return "coming-soon"
  // In-store is in stock but not shippable, so like coming-soon it dominates variant stock.
  if (stockValue === inStore) return "in-store"
  // Out-of-stock is set at product level, so it overrides a variant that still reads as sellable.
  if (stockValue === outOfStock) return "oos-no-action"
  if (variant?.availableForSale) return "available"
  if (stockValue === backSoon) return "oos-notify"
  return "oos-no-action"
}

export const availabilityMeta = (state: VariantAvailabilityState) => ({
  // Story 1: an OOS-no-action variant cannot be selected or added.
  isSelectable: state !== "oos-no-action",
  // Any non-available state greys the thumbnail.
  isGreyed: state !== "available",
  // Only Story 1 gets the strikethrough thumbnail.
  hasStrikethrough: state === "oos-no-action",
  // Stories 2 + 3 route the CTA through the notify-me capture; in-store is in stock, so it never does.
  isNotify: state === "oos-notify" || state === "coming-soon",
})
